var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconDuplicate = function SvgIconDuplicate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 19.5H8.68V7.82h9.14zm0-13.32H8.68q-.705 0-1.211.468-.47.469-.469 1.172V19.5q0 .703.469 1.172.508.468 1.21.507h9.141q.704-.039 1.172-.507.508-.47.508-1.172V7.82q0-.704-.508-1.172-.468-.468-1.172-.469m-2.5-3.36h-10q-.703.039-1.172.508-.468.468-.468 1.172v11.68h1.64V4.5h10z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconDuplicate);
export { ForwardRef as ReactComponent };